import React from "react";
import { TableCell, TableSortLabel, TableRow } from "@mui/material";

interface RoleTableHeadingProps {
  order: "asc" | "desc";
  orderBy: string;
  onSort: (property: string) => void;
}

const TableHeading: React.FC<RoleTableHeadingProps> = ({ order, orderBy, onSort }) => {
  const commonCellStyle = { fontSize: 14 };
  const cellStyles = { width: "120px", ...commonCellStyle };
  const roleCellStyles = { width: "200px", ...commonCellStyle };
  const pageCellStyles = { width: "250px", ...commonCellStyle };
  const actionCellStyles = { width: "150px", ...commonCellStyle };

  const createSortHandler = (property: string) => () => {
    onSort(property);
  };

  return (
    <TableRow>
      <TableCell
        sx={{ ...cellStyles, fontWeight: "bold", color: "#000" }}
        sortDirection={orderBy === "sno" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "sno"}
          direction={orderBy === "sno" ? order : "asc"}
          onClick={createSortHandler("sno")}
        >
          S.No.
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={{ ...roleCellStyles, fontWeight: "bold", color: "#000" }}
        sortDirection={orderBy === "role" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "role"}
          direction={orderBy === "role" ? order : "asc"}
          onClick={createSortHandler("role")}
        >
          Role
        </TableSortLabel>
      </TableCell>

      <TableCell
        sx={{ ...pageCellStyles, fontWeight: "bold", color: "#000" }}
        sortDirection={orderBy === "page" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "page"}
          direction={orderBy === "page" ? order : "asc"}
          onClick={createSortHandler("page")}
        >
          Pages
        </TableSortLabel>
      </TableCell>



      <TableCell sx={{ ...actionCellStyles, fontWeight: "bold", color: "#000" }} align="center">
        Action
      </TableCell>
    </TableRow>
  );
};

export default TableHeading;
